/** Communautés officielles ISBD (WhatsApp, Facebook, TikTok…). */

export const COMMUNITY_PLATFORMS = [
  { key: 'whatsapp', label: 'WhatsApp', tone: 'green' },
  { key: 'facebook', label: 'Facebook', tone: 'blue' },
  { key: 'tiktok', label: 'TikTok', tone: 'navy' },
  { key: 'telegram', label: 'Telegram', tone: 'teal' },
  { key: 'linkedin', label: 'LinkedIn', tone: 'blue' },
  { key: 'instagram', label: 'Instagram', tone: 'orange' },
  { key: 'youtube', label: 'YouTube', tone: 'orange' },
  { key: 'autre', label: 'Autre', tone: 'gold' },
] as const;

export type CommunityPlatform = (typeof COMMUNITY_PLATFORMS)[number]['key'];

export function communityPlatformLabel(platform: string): string {
  return COMMUNITY_PLATFORMS.find((p) => p.key === platform)?.label ?? platform;
}

export function communityPlatformTone(platform: string): string {
  return COMMUNITY_PLATFORMS.find((p) => p.key === platform)?.tone ?? 'navy';
}

/** Icône simple pour l’UI abonné (liste Communauté). */
export function communityPlatformIcon(platform: string): string {
  switch (platform) {
    case 'whatsapp':
      return '💬';
    case 'facebook':
      return '📘';
    case 'tiktok':
      return '🎵';
    case 'telegram':
      return '✈️';
    case 'linkedin':
      return '💼';
    case 'instagram':
      return '📷';
    case 'youtube':
      return '▶️';
    default:
      return '🌐';
  }
}

